export default function LimitContentFilter() {
    'ngInject';

    return (content, charLimit, lineLimit) => {
        const data = content || '';

        const input = (typeof data == 'object') ? JSON.stringify(data) : data;

        if (input && charLimit && input.length > charLimit) {
            return input.slice(0, charLimit) + '...';
        }

        if (input && lineLimit) {
            const inputLines = input.split('\n').filter(s => s.trim());
            if(inputLines.length > lineLimit){
                return inputLines.slice(0, lineLimit).join('\n') + '...';
            }
        }

        return input;
    };
}
